/**
 * Status bucketing for the "Requests By Type" widget.
 *
 * request_parent.status is a free-text varchar that in practice holds
 * new / "in progress" / completed / pending / canceled (note the space in
 * "in progress", not an underscore). The Penpot design shows 4 buckets, so we
 * collapse the real statuses into them:
 *   new / pending / unknown        → Open      (not started / waiting)
 *   "in progress" / in_progress    → In Progress
 *   completed / complete           → Closed
 *   canceled / cancelled           → Lost
 *
 * Unknown values fall through to Open so a count is never silently dropped.
 */

export type RequestLegendKey = "open" | "in_progress" | "closed" | "lost";

export function bucketRequestStatus(raw: string): RequestLegendKey {
  const normalized = raw.toLowerCase().trim();
  if (normalized === "in progress" || normalized === "in_progress") return "in_progress";
  if (normalized === "completed" || normalized === "complete") return "closed";
  if (normalized === "canceled" || normalized === "cancelled") return "lost";
  return "open";
}

/** Title-case a free-text type label ("spring start up" → "Spring Start Up"). */
export function titleCase(value: string): string {
  return value
    .split(/[\s_]+/)
    .filter(Boolean)
    .map((w) => w[0].toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}
